import { render, staticRenderFns } from "./VatFilter.vue?vue&type=template&id=1ed2609e&scoped=true"
import script from "./VatFilter.vue?vue&type=script&lang=js"
export * from "./VatFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2609e",
  null
  
)

export default component.exports